export function splitRangeDatePickerValue(date) {
  if (Array.isArray(date) && date.length === 2) {
    const [start, end] = date;
    return [start, end];
  }
}
